(function autoCloseDetails() {
  document.addEventListener('click', function (event) {
    const target = event.target instanceof Element ? event.target : null;
    const menuLink = target?.closest('.menu-drawer a[href]');

    if (menuLink && window.matchMedia('(max-width: 749px)').matches) {
      const drawer = menuLink.closest('details.menu-drawer-container');

      if (drawer?.open) {
        const trigger = drawer.querySelector(':scope > summary');
        if (trigger instanceof HTMLElement) trigger.click();
        else drawer.open = false;
      }
    }

    const detailsToClose = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        const closingOn = window.innerWidth < 750 ? 'mobile' : 'desktop';
        return (
          element.getAttribute('data-auto-close-details')?.includes(closingOn) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    for (const detailsElement of detailsToClose) detailsElement.open = false;
  });
})();
